import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'

import { App } from '@/app/App'

import './index.css'

// Новый деплой удаляет старые JS-чанки; вкладки со старым бандлом падают на
// ленивом импорте роутов. Перезагружаем один раз, чтобы подтянуть свежий бандл.
window.addEventListener('vite:preloadError', (event) => {
  // Уже перезагружались — не глушим, пусть ошибка уйдёт в Sentry как реальная.
  if (sessionStorage.getItem('vite-preload-reloaded')) return
  // Гасим ре-throw Vite: разовый stale-чанк после деплоя, не баг — в Sentry не нужен.
  event.preventDefault()
  sessionStorage.setItem('vite-preload-reloaded', '1')
  window.location.reload()
})

const dsn = import.meta.env.VITE_SENTRY_DSN

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
      Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
      Sentry.httpClientIntegration(),
    ],
    enableLogs: true,
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 1.0),
    // Бесплатная квота — 50 записей в месяц: пишем только сессии с ошибкой.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/api\.ai-manager\.website/],
    attachStacktrace: true,
  })
}

const container = document.getElementById('root')

if (!container) {
  throw new Error('Root container not found')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

sessionStorage.removeItem('vite-preload-reloaded')
